module.exports = __webpack_public_path__ + "images/questions/qa_balloon_04_fe523dfe9bcf27be4a618b6780bc2ba0.png";